import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from 'src/app/services';
import { LoginResponse } from '../interfaces';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private _localStorageService = inject(LocalStorageService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Define los endpoints que requieren autorización
    const protectedEndpoints = [
      '/api/update-personal-information',
      '/api/get-personal-routes-saved',
      '/api/delete-user-login',
      '/api/webapp-user-profile',
      '/api/gamification/passports',
      '/api/gamification/badges/seal',
      '/api/resource-valoration',
      '/api/get-event-app-details',
      '/api/get-point-app-details',
      '/api/get-hiking-app-details',
      '/api/wallet/tickets',
      '/api/wallet/orders',
      '/api/ticketing/create-order',
      // Favoritos (HRS-3615): el CMS pasará a tomar el usuario del token en vez de la URL.
      '/api/save-events-wallet',
      '/api/get-events-wallet',
      '/api/delete-event-wallet',
      '/api/save-interest-points-wallet',
      '/api/get-interest-points-wallet',
      '/api/delete-interest-point-wallet',
      '/api/save-routes-wallet',
      '/api/get-routes-wallet',
      '/api/delete-route-wallet',
      '/api/save-hikings-wallet',
      '/api/get-hikings-wallet',
      '/api/delete-hiking-wallet'
    ];

    // Verifica si la URL del request es uno de los protegidos
    const isProtected = protectedEndpoints.some(endpoint => req.url.includes(endpoint));

    if (isProtected) {
      const loginResponseLocalStorage = this._localStorageService.getItem<LoginResponse>('loginResponse');
      if (!loginResponseLocalStorage) {
        return next.handle(req);
      }

      const token = loginResponseLocalStorage.data.access_token;
      
      if (token) {
        const authReq = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` }
        });
        return next.handle(authReq);
      }
    }
    return next.handle(req);
  }
}